import * as React from 'react'

import Ui from '../../../ui'
import ZentakeFormContext from '../ZentakeFormContext'

function StripeCardQuestion({ question, response }) {
  const { isQuestionReadonly, getAnswer, isQuestionDirty } =
    React.useContext(ZentakeFormContext)

  const isDirty = isQuestionDirty(question)

  const answer = getAnswer(question)

  return (
    <Ui.StripeCard
      error={isDirty && 'This field is required'}
      filled={answer}
      isRequired={question.is_required}
      label={question.text}
      readOnly={isQuestionReadonly(question)}
      response={response}
    />
  )
}

export default StripeCardQuestion
